<template>
  <v-alert v-if="unsupported" type="warning">
    {{ $t('fresh-vue.AlertUnsupportedBrowser.message') }}
  </v-alert>
</template>

<script>
import { detect } from 'detect-browser'

export default {
  name: 'AlertUnsupportedBrowser',

  computed: {
    unsupported() {
      const browser = detect()
      return browser && browser.name === 'ie'
    }
  }
}
</script>
